import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { downloadFile } from 'helper';
import { exportAllPartnersRatingByPartnerUgoExcel } from '../api';

export function useExportAllPartnersRatingByPartnerUgoExcelReport() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const exportAllPartnersRatingByPartnerUgoExcelReport = async (config?: AxiosRequestConfig) => {
    setLoading(true);

    try {
      downloadFile(
        await exportAllPartnersRatingByPartnerUgoExcel(config),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Отчет по всем партнерам УГО.xlsx',
      );
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, exportAllPartnersRatingByPartnerUgoExcelReport };
}
